import Dashboard from "../components/dashboard/Dashboard";
import InstructorForgotPassword from "../components/forgotPassword/InstructorForgotPassword";
import InstructorNavbar from "../components/instructor/InstructorNavbar";
// import Navbar from "../components/layout/Navbar";


const InstructorForgotPasswordPage = () => {
    return ( 
        <>
        <InstructorNavbar/>
        <InstructorForgotPassword/>
        </>
     );
}
 
export default InstructorForgotPasswordPage;